export type IQueryParams = { info: string; tk: string; from: string }

export enum FromParam {
    I2A_EMAIL_FEEDBACK = "i2a-email-feedback",
    FEEDBACK_PAGE = "feedback-page",
}
